import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class ProspectsService {

	constructor(private http: HttpClient, private utils: UtilsService) {}

	uploadProspects(prospects: any, campaignId: number ){
		const url = `${environment.api}prospects/upload_prospects`;
		const formData: any = this.utils.jsonToFormData({ prospects: JSON.stringify(prospects), campaignId: campaignId});
		return this.http.post(url, formData);
	}

	uploadFileProspects(formData, campaign_id: number, json_columns: string) {
		const url = `${environment.api}prospects/upload_file_prospects`;
		formData.append('campaign_id', campaign_id);
		formData.append('json_columns', json_columns);
		return this.http.post(url, formData);
	}

	getDisposByPhone(phone: string){
		const url = `${environment.api}prospects/${phone}/get_dispos_by_phone`;
		return this.http.get(url);

	}

	deleteRelatedProspects(campaign_id: number){
		const url = `${environment.api}prospects/${campaign_id}/delete_related_prospects`;
		return this.http.get(url);
	}

	countHowManyProspects(campaign_id: number){
		const url = `${environment.api}prospects/${campaign_id}/count_how_many_prospects`;
		return this.http.get(url);
	}

	getProspects(campaign_id: number) {
		const url = `${environment.api}prospects/${campaign_id}/get_prospects_from_campaign`;
		return this.http.get(url);
	}

	searchProspects(campaign_id: number, searchValue: string, prospects_from: string) {
		const url = `${environment.api}prospects/search_prospects`;
		const formData: any = this.utils.jsonToFormData({ searchValue, campaign_id, prospects_from });
		return this.http.post(url, formData);
	}

	assignToCampaign(campaign_id: number, prospect_ids: string) {
		const url = `${environment.api}prospects/assign_to_campaign`;
		const formData: any = this.utils.jsonToFormData({ campaign_id, prospect_ids });
		return this.http.post(url, formData);
	}

	unassignFromCampaign(campaign_id: number, searchValue: any) {
		const url = `${environment.api}prospects/unassign_from_campaign`;
		const formData: any = this.utils.jsonToFormData({ campaign_id, searchValue });
		return this.http.post(url, formData);
	}

	setRelProspectsCampaigns(campaign_id: number){
		const url = `${environment.api}prospects/${campaign_id}/set_rel_prospects_campaigns`;
		return this.http.get(url);
	}

}
